import { render, staticRenderFns } from "./OngoingDateBadge.vue?vue&type=template&id=5256795f&"
import script from "./OngoingDateBadge.vue?vue&type=script&lang=js&"
export * from "./OngoingDateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports